import React, { Component } from 'react';
import Input from "./Input";
import Messages from "./Messages";
import './App.css';


class App extends Component {

  render() {
    return (
        <div className="panel-body">
            <Messages />
            <Input />
        </div>
    );
  }
}

export default App;
